var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{on:{"click":function($event){_vm.$emit('click')}}},[_c('Card',{staticClass:"card-button base-simple-card",attrs:{"shadow":""}},[_c('p',{staticClass:"card-simple-button-text"},[_vm._v(_vm._s(_vm.text))])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }